module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sh-ta-fce686de2922d8501b924102231b1afe.svg";